import { ConfigProvider } from "antd";
import { Navigate, Route, Routes } from "react-router-dom";
import DashboardLayout from "./components/layout/DashboardLayout";
import { useAuthManager } from "./hooks/useAuthManager";
import "./i18n";
import AccountsForm from "./pages/AccountsForm";
import BusinessAccounts from "./pages/BusinessAccounts";
import Campaigns from "./pages/Campaigns";
import CampaignsForm from "./pages/CampaignsForm";
import Features from "./pages/Features";
import FeaturesDetails from "./pages/FeaturesDetails";
import Home from "./pages/Home";
import Journal from "./pages/Journal";
import JournalForm from "./pages/JournalForm";
import Outlets from "./pages/Outlets";
import Payouts from "./pages/Payouts";
import Settings from "./pages/Settings";
import SettingsAccount from "./pages/SettingsAccount";
import SettingsAccountPass from "./pages/SettingsAccountPass";
import SettingsRoles from "./pages/SettingsRoles";
import Signin from "./pages/Signin";
import Stampcards from "./pages/Stampcards";
import Subscriptions from "./pages/Subscriptions";
import PromoCodes from "./pages/PromoCodes";
import UsersAccounts from "./pages/UserAccounts";
import Loading from "./utils/Loading";

function App() {
  const { isLoading, isAuthenticated } = useAuthManager();

  return (
    <div className="App">
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: "#f11e69",
            colorLinkHover: "#f11e69",
          },
        }}
      >
        {isLoading ? (
          <Loading />
        ) : (
          <Routes>
            {/* SignIn page accessible to unauthenticated users */}
            <Route
              path="/signin"
              element={isAuthenticated ? <Navigate to="/home" /> : <Signin />}
            />

            {/* Dashboard page with child routes, protected by authentication */}
            <Route
              path="/*"
              element={
                isAuthenticated ? (
                  <DashboardLayout />
                ) : (
                  <Navigate to="/signin" />
                )
              }
            >
              {/* Home Paths */}
              <Route path="" element={<Home />} index />
              <Route path="home" element={<Home />} />
              <Route path="overview" element={<Home />} />

              {/* Features Paths */}
              <Route path="features" element={<Features />} />
              <Route
                path="features/:accUrn/:businessUrn/:businessSlug/*"
                element={<FeaturesDetails />}
              />

              {/* Acounts Paths */}
              <Route path="accounts" element={<BusinessAccounts />} />
              <Route path="accounts/:id" element={<AccountsForm />} />

              <Route path="user-accounts" element={<UsersAccounts />} />
              <Route path="subscriptions" element={<Subscriptions />} />
              <Route path="promo-codes" element={<PromoCodes />} />
              <Route path="Payouts" element={<Payouts />} />

              {/* Campaigns Paths */}
              <Route path="campaigns" element={<Campaigns />} />
              <Route path="campaigns/create" element={<CampaignsForm />} />
              <Route path="campaigns/edit/:id" element={<CampaignsForm />} />

              <Route path="outlets" element={<Outlets />} />

              {/* Stampcards Paths */}
              <Route path="stamp-cards" element={<Stampcards />} />

              {/* Journal Paths */}
              <Route path="journal" element={<Journal />} />
              <Route path="journal/add" element={<JournalForm />} />

              <Route path="settings" element={<Settings />} />
              <Route path="settings/account" element={<SettingsAccount />} />
              <Route
                path="settings/account/change-password"
                element={<SettingsAccountPass />}
              />
              <Route path="settings/roles" element={<SettingsRoles />} />
            </Route>
          </Routes>
        )}
      </ConfigProvider>
    </div>
  );
}

export default App;
